import React from 'react';
import CaseStudyLayout from '@/components/CaseStudyLayout';

const EcommerceLuxuryGenevaCase = () => {
  const caseStudy = {
    id: 'ecommerce-luxury-geneva',
    company: 'Luxury E-Shop Genève',
    industry: 'E-Commerce Luxe',
    service: 'Vidéos Produits IA + Webdesign Premium',
    duration: '8 mois',
    image: 'https://images.unsplash.com/photo-1516321497487-e288fb19713f?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
    challenge: 'Ce e-commerce de luxe genevois avait du mal à convertir les visiteurs en acheteurs. Malgré un trafic de 5,600 visiteurs mensuels, le taux de conversion restait faible à 0.8%. Les produits de luxe nécessitaient une présentation visuelle exceptionnelle que les photos statiques ne pouvaient pas offrir. La clientèle francophone exigeante n\'était pas convaincue par l\'expérience d\'achat en ligne.',
    solution: 'Nous avons créé des vidéos produits IA sophistiquées pour chaque article, mettant en valeur les détails luxueux sous tous les angles. Le nouveau webdesign premium reflétait l\'exclusivité de la marque avec une UX optimisée pour la clientèle aisée. Optimisation SEO pour "luxe Genève", "shopping de luxe Suisse" et intégration d\'avis clients vidéo personnalisés.',
    results: {
      traffic: { before: '5,600', after: '18,900' },
      leads: { before: '28', after: '156' },
      conversion: { before: '0.8%', after: '2.9%' }
    },
    testimonial: {
      quote: 'Future Level a transformé notre boutique en ligne en une expérience digne de nos produits de luxe. Les vidéos IA capturent la qualité exceptionnelle de nos articles, et nos ventes ont explosé. Le ROI a dépassé toutes nos attentes.',
      author: 'Marie-Claire Dubois',
      position: 'Directrice, Luxury E-Shop Genève'
    }
  };

  return <CaseStudyLayout caseStudy={caseStudy} />;
};

export default EcommerceLuxuryGenevaCase;